import { gql } from '@apollo/client'

export const ON_SIGNUP = gql`
mutation OnSignUp($user: UserInput) {
  onSignUp(user: $user)
}`

export const ON_LOGIN = gql`
mutation OnLogin($user: UserInput) {
  onLogin(user: $user)
}`

export const CREATE_PRESENTATION = gql`
mutation CreatePresentation($present: PresentInput) {
  createPresentation(present: $present)
}`

export const UPDATE_PRESENTATION = gql`
mutation UpdatePresentation($updatePresentationId: String, $present: PresentInput) {
  updatePresentation(id: $updatePresentationId, present: $present)
}`

export const CREATE_SLIDE = gql`
mutation CreateSlide($slide: SlideInput) {
  createSlide(slide: $slide)
}`

export const DELETE_SLIDE = gql`
mutation DeleteSlide($deleteSlideId: String) {
  deleteSlide(id: $deleteSlideId)
}`

export const UPDATE_PRESENTATION_STATUS = gql`
mutation UpdatePresentationStatus($updatePresentationStatusId: String, $status: String, $code: Float, $activeSlide: String) {
  updatePresentationStatus(id: $updatePresentationStatusId, status: $status, code: $code, activeSlide: $activeSlide)
}`

export const JOIN_PRESENTATION = gql`
mutation OnJoin($name: String, $code: Float, $email: String) {
  onJoin(name: $name, code: $code, email: $email)
}`

export const CREATE_ANSWER = gql`
mutation CreateAnswer($answer: AnswerInput) {
  createAnswer(answer: $answer)
}`

export const DELETE_PARTICIPANT = gql`
mutation DeleteParticipant($deleteParticipantId: String) {
  deleteParticipant(id: $deleteParticipantId)
}`